import React, { useId } from 'react';

interface Props {
  /** Rendered width/height in px. */
  px: number;
  className?: string;
}

/**
 * The gradient verified-shield glyph (teal→indigo, white check). Shared by
 * VerifiedShieldBadge (interactive, tap tooltip) and VerifiedChip (the listing
 * trust chip) so the SVG lives in exactly one place.
 */
const VerifiedShieldIcon: React.FC<Props> = ({ px, className }) => {
  // Unique gradient id per instance: a shared id collides across the many
  // shields on a page, and browsers resolve every url(#id) to the first one in
  // the document — often a hidden 0×0 shield that paints nothing (JAA-305).
  const gradId = `vsb-grad-${useId().replace(/:/g, '')}`;
  return (
    <svg viewBox="0 0 24 24" width={px} height={px} className={className} aria-hidden="true">
      <defs>
        <linearGradient id={gradId} x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#00B8DF" />
          <stop offset="100%" stopColor="#3E55CD" />
        </linearGradient>
      </defs>
      <path
        d="m3 10.35c0 5.67 3.17 9 8.15 11.46a2 2 0 0 0 1.7 0c4.98-2.41 8.15-5.81 8.15-11.46v-4.66a2 2 0 0 0 -1.8-2 22.61 22.61 0 0 1 -6.44-1.54 1.91 1.91 0 0 0 -1.52 0 22.61 22.61 0 0 1 -6.44 1.55 2 2 0 0 0 -1.8 2z"
        fill={`url(#${gradId})`}
      />
      <path
        d="m11.23 14.77a1 1 0 0 1 -.7-.28l-2.28-2.24a1 1 0 0 1 0-1.42 1 1 0 0 1 1.41 0l1.58 1.55 4.11-4a1 1 0 0 1 1.41 1.43l-4.81 4.73a1 1 0 0 1 -.72.23z"
        fill="#fff"
      />
    </svg>
  );
};

export default VerifiedShieldIcon;
